module.exports = __webpack_public_path__ + "img/document-download.d6866005.svg";